import React from 'react';
import { useNavigate } from 'react-router-dom';
import './QuoteButton.css';

const QuoteButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/orcamento'); // Redireciona para a página "orcamento"
  };

  return (
    <div className="quote-button-container">
      <button className="blinking-button" onClick={handleClick}>
        Solicite um Orçamento
      </button>
    </div>
  );
};

export default QuoteButton;
